import React from 'react';
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

import Loading from '../../shared/Loading';
import useSessionEntity from '../../../hooks/useSessionEntity';
import { Components } from 'ck-shared';
import { pdIsExpired } from '../../../constants/PersistentData';
import { saveToken } from '../../../actions/users';
import {
  afterAuthRoute,
  loading
}
  from '../../../actions/sessions';

export default function PinVerification({ location, match }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const application = useSessionEntity('application');
  const isLoading = useSelector(state => state.sessions.get('loading'));

  const exceededPhoneChanges = () => application.phone_change_attempts >= 1;

  const tryAnotherOptionText = () => {
    if (!exceededPhoneChanges()) {
      return (
        <div className="has-text-centered mt-5 is-size-6">
          <p className="has-text-weight-bold">Didn't receive the code?</p>
          <Link to="/purchase/phone">Go back and try a different mobile phone number</Link>
        </div>
      );
    }
  };

  const afterAuthCallback = (twofactor) => {
    return dispatch(afterAuthRoute(history, twofactor));
  };


  const onLockout = () => {
    history.push('/init/user_lockout');
  };

  const onNotBorrower = () => {
    history.push('/init/user_is_not_borrower');
  }

  return (
    <div id="content">
      <div className="has-text-centered mb-5">
        <div className="is-size-4 has-text-weight-semibold">We just texted you.</div>
        Please enter the 6-digit code we sent you.
      </div>

      <Components.UserTokenVerification
        expired={pdIsExpired()}
        isLoading={isLoading}
        match={match}
        onAfterAuth={afterAuthCallback}
        onLoading={loading}
        onLockout={onLockout}
        onNotBorrower={onNotBorrower}
        onSaveToken={saveToken}
        twofactor={true}
      >
        <Loading active={true} />
      </Components.UserTokenVerification>

      {tryAnotherOptionText()}
    </div>
  )
}
